import { useState, useCallback } from 'react';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useResolveCampaignNames } from './hooks/useResolveCampaignNames';
import CampaignsPlatformListPopover from './CampaignsPlatformListPopover';
import { View } from 'foundations-components/components/View';
import { useFetchObjectPropertyDefinitions } from './hooks/useFetchObjectPropertyDefinitions';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CampaignsPlatformTableCell = ({
  crmObject,
  assetName,
  objectType
}) => {
  var _ref;
  const [open, setOpen] = useState(false);
  const campaignGUIDsValue = getPropertyValue(crmObject, 'hs_campaign_names') || getPropertyValue(crmObject, 'hs_campaign_guids');
  const campaignGUIDs = campaignGUIDsValue ? campaignGUIDsValue.split(';').filter(Boolean) : [];
  const campaignCount = campaignGUIDs.length;
  const {
    campaigns,
    loading,
    error
  } = useResolveCampaignNames(campaignGUIDs, {
    objectTypeId: crmObject.objectTypeId
  });
  const {
    data: objectDefinition
  } = useFetchObjectPropertyDefinitions({
    objectType: objectType || crmObject.objectTypeId
  });
  const assetLabel = (_ref = assetName !== null && assetName !== void 0 ? assetName : objectDefinition === null || objectDefinition === void 0 ? void 0 : objectDefinition.singularForm) !== null && _ref !== void 0 ? _ref : '';
  const handleOpenChange = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
  }, []);
  if (campaignCount === 0 || error) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "--"
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "20px",
      minInlineSize: "100px",
      inlineSize: "100%",
      backgroundColor: "fill-primary-disabled",
      "data-test-id": "campaign-cell-loading"
    });
  }

  // if there's just 1 campaign then show a single link
  if (campaignCount === 1) {
    var _campaigns$;
    const campaignName = ((_campaigns$ = campaigns[0]) === null || _campaigns$ === void 0 ? void 0 : _campaigns$.label) || campaignGUIDs[0];
    return /*#__PURE__*/_jsx(Link, {
      href: `/marketing/${PortalIdParser.get()}/campaigns/${campaignGUIDs[0]}`,
      "data-test-id": "campaign-cell-link",
      children: campaignName
    });
  }
  return /*#__PURE__*/_jsx(Popover, {
    open: open,
    placement: "left",
    onOpenChange: handleOpenChange,
    content: /*#__PURE__*/_jsx(CampaignsPlatformListPopover, {
      campaigns: campaigns,
      assetName: assetLabel
    }),
    inlineSize: "320px",
    children: /*#__PURE__*/_jsx(Link, {
      onClick: handleOpenChange,
      "data-test-id": "campaign-cell-link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignTableCell.campaigns",
        options: {
          count: campaignCount
        }
      })
    })
  });
};
export default CampaignsPlatformTableCell;